import { Col, Card } from 'react-bootstrap';
import { Link } from "react-router-dom";
import moment from 'moment';
import { CiLocationOn, CiCalendar, CiTrophy } from "react-icons/ci";
import Countdown from 'react-countdown';
import { IoMdClose } from 'react-icons/io';
import { PiClockClockwiseFill } from "react-icons/pi";

// Images
import { Logo } from "../../assets/images/svg";

// Utils
import { convertGender } from '../../utils/helper';

export const TournamentCard = (props) => {
    return <Col xs={12} sm={6} md={4} lg={3} className='p-3'>
        <Link to={`/tournament/${props?.item?.id}`} className='text-dark text-decoration-none'>
            <Card className='rounded-3 h-100'>
                <div className='position-relative'>
                    <Card.Img variant="top" src={props?.item?.banner_image} />
                    <Logo className='position-absolute top-100 end-0 mt-n4 me-2' />
                    {props?.organizer ? moment(new Date(props?.item?.registration_end_date)).diff(moment(new Date()), 'days') >= 0 ?
                        <span className='position-absolute top-100 start-0 bg-success text-light px-3 py-1 mt-n4 ms-3 rounded-pill fs-12 fw-500'>Open</span>
                        :
                        <span className='position-absolute top-100 start-0 bg-danger text-light px-3 py-1 mt-n4 ms-3 rounded-pill fs-12 fw-500'>Closed</span>
                        :
                        <></>
                    }
                </div>
                <Card.Body className='mt-3'>
                    <div className='d-grid'>
                        <Card.Title className='fs-18 fw-600 text-blue text-truncate text-capitalize'>{props?.item?.name}</Card.Title>
                    </div>
                    <div className='d-flex align-items-start mb-2'>
                        <div className='me-2'>
                            <CiLocationOn className='text-primary' size={20} />
                        </div>
                        <span className='fs-12 fw-400 text-secondary tournament-card-location'>{props?.item?.address}</span>
                    </div>
                    {props?.history ?
                        <>
                            <div className='d-flex align-items-start mb-2'>
                                <CiCalendar className='text-primary me-2' size={20} />
                                <div className='d-flex flex-column align-items-start'>
                                    <span className='fs-12 fw-500 text-secondary'>Registration</span>
                                    <span className='fs-12 fw-600 text-dark'>{props?.item?.registration_start_date} to {props?.item?.registration_end_date}</span>
                                </div>
                            </div>
                            <div className='d-flex align-items-start'>
                                <CiTrophy className='text-primary me-2' size={20} />
                                <div className='d-flex flex-column align-items-start'>
                                    <span className='fs-12 fw-500 text-secondary'>Tournament</span>
                                    <span className='fs-12 fw-600 text-dark'>{props?.item?.tournament_start_date} to {props?.item?.tournament_end_date}</span>
                                </div>
                            </div>
                        </>
                        :
                        props?.closingSoon ?
                            <div>
                                <PiClockClockwiseFill className='text-success me-2' size={20} />
                                <Countdown date={moment(props?.item?.registration_end_date)?.endOf('day').toDate()} renderer={({ days, hours, minutes, seconds }) => {
                                    return <span className='fs-12 text-success fw-500 mb-3'>{days > 0 && `${days} day `}{hours < 10 ? `0${hours}:` : `${hours}:`}{`${minutes}:`}{`${seconds}`} hrs</span>;
                                }} />
                            </div>
                            :
                            <>
                                <div className='d-flex align-items-start mb-2'>
                                    <CiCalendar className='text-primary me-2' size={20} />
                                    <div className='d-flex flex-column align-items-start'>
                                        <span className='fs-12 fw-500 text-secondary'>Registration</span>
                                        <span className='fs-12 fw-600 text-dark'>{props?.item?.registration_start_date} to {props?.item?.registration_end_date}</span>
                                    </div>
                                </div>
                                <div className='d-flex align-items-start'>
                                    <CiTrophy className='text-primary me-2' size={20} />
                                    <div className='d-flex flex-column align-items-start'>
                                        <span className='fs-12 fw-500 text-secondary'>Tournament</span>
                                        <span className='fs-12 fw-600 text-dark'>{props?.item?.tournament_start_date} to {props?.item?.tournament_end_date}</span>
                                    </div>
                                </div>
                            </>
                    }
                </Card.Body>
            </Card>
        </Link>
    </Col>
}

export const BankAccountCard = (props) => {
    return <div className='d-flex align-items-center w-100'>
        <img className='img-fluid bank-image me-3' src={props?.item?.bank?.image} alt={props?.item?.bank?.name} />
        <div className='d-flex flex-column align-items-start flex-grow-1'>
            <span className='fs-18 fw-600 mb-2 text-capitalize'>{props?.item?.bank?.name}</span>
            <span className='fs-14 text-secondary'>Holder name : {props?.item?.holder_name}</span>
            <span className='fs-14 text-secondary'>Account no. : {props?.item?.account_number}</span>
        </div>
    </div>
}

export const PlayerCard = (props) => {
    return <div className='d-flex flex-column align-items-start mt-3 bg-danger bg-opacity-10 w-100 px-3 py-2 border rounded position-relative'>
        <span className='fs-14 fw-600 mb-2'>Player {props?.index + 1}</span>
        <span className='fw-600 text-primary'>{props?.item?.player_name}</span>
        <div className='d-flex flex-wrap justify-content-between align-items-center fs-14 fw-500 w-100'>
            <div className='d-flex flex-wrap align-items-center'>
                <span className='me-2'>{props?.item?.player_gender ? convertGender(props?.item?.player_gender) : '-'}</span>
                <span className='me-2'>.</span>
                <span className='me-2'>{props?.item?.player_email}</span>
                <span className='me-2'>.</span>
                <span>{props?.item?.player_contact}</span>
            </div>
        </div>
        {props?.item?.tshirt_details &&
            <span className='fs-14 fw-500 mt-1'>T-Shirt : {props?.item?.tshirt_details?.tshirt?.tshirt_name} ({props?.item?.tshirt_details?.size?.size})</span>
        }
        {props?.tournament?.sports_type === "PICKLEBALL" && props?.item?.dupr_rating && <span className='fs-14 fw-500 mt-1'>DUPR Rating : {props?.item?.dupr_rating}</span>}
        <IoMdClose role='button' className='position-absolute top-0 end-0 mt-2 me-3' color='red' size={20} onClick={() => props?.removePlayer(props?.item?.id, props?.tournament?.id)} />
    </div>
}
